{
  "Mon": "Montag",
  "Tue": "Dienstag",
  "Wed": "Mittwoch",
  "Thu": "Donnerstag",
  "Fri": "Freitag",
  "Sat": "Samstag",
  "Sun": "Sonntag",
  "CORE": {
    "notificationDateFormat": "dd.MM.yyyy",
    "update": "Lade...",
    "youAreOffline": "Du bist offline! Verbinde dich mit einem Netzwerk und versuche es später noch einmal!",
    "comeBack": "{{icon}} Deine Ski warten",
    "help": "Hilfe",
    "notification": {
      "ok": "Verstanden"
    },
    "skiHire": "Skiverleih"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Bezahlen Sie in Ihrer Heimatwährung (EUR oder CHF). Alpy.com übernimmt für Sie die Wechselkursgebühren."
      },
      "showTownReserveEarlyEnoughInfo": "Bitte beachten Sie, dass Skiverleiher während der Saison Materialengpässe haben können. Wir empfehlen daher immer im Vorhinein zu reservieren."
    },
    "PF": {
      "start": {
        "selectBookingParametersFact3": "Über 600 Verleih-Shops online"
      },
      "showTownReserveEarlyEnoughInfo": "Bitte beachten Sie, dass es während der Skisaison zu einem Materialengpass kommen kann. Wir empfehlen Ihnen rechtzeitig zu buchen.",
      "heroBenefits": {
        "headline": "Jetzt die besten Verleih-Preise sichern",
        "subheadline": "Bis zu <span>-{{discount}}%</span> Billiger*",
        "benefitsHeader": "Vorteile",
        "benefitFirst": "Jetzt bis zu -{{discount}}% Einsparungen im Vergleich zu den Preisen in den Geschäften",
        "benefitSecond": "Keine sonstigen Gebühren",
        "benefitThird": "Flexible Stornierung & Umbuchung",
        "benefitFourth": "Online buchen - im Shop abholen"
      }
    },
    "offer": {
      "title": "Deswegen mit {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Sichern Sie sich die besten Verleih-Preise durch Ihre Onlinebuchung",
      "searchHeadline": "In welchem Ort möchten Sie Skier oder ein Snowboard leihen?",
      "listedBrands": "Geführte Marken",
      "topTowns": "Top Skiverleih-Orte"
    },
    "sidebar": {
      "hotlineItalic": "Wir helfen Ihnen gerne!",
      "callNow": "Rufen Sie uns an: ",
      "hotline": "Hotline"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Bitte geben sie von jedem Kind das Alter an. (Alter bei Mietantritt)",
        "onePersonRequired": "Mindestens eine Person auswählen",
        "enterTown": "Bitte geben Sie einen Ort an"
      },
      "minified": {
        "users": "{{ number_adults }} Erwachsene, {{ number_children }} Kinder",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE dd.MM.yy"
      },
      "datePickerDisplayFormat": "EEEEEE dd.MM.yy",
      "datePickerPreviousMessage": "Sie können Ihr Material bereits am <span>{{ date }}</span> ab 15:30 beim Shop abholen. Nachtskilauf ausgenommen.",
      "datePickerPreviousMessageDateFormat": "dd.MM.yy",
      "formSearchLabel": "Ort, Skigebiet, Bundesland, Land, Shopname, ...",
      "formSearchInfo": "Einen Moment bitte, ihr gewünschter Ort wird gesucht...",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "{{ count }} Shop(s)",
      "formSearchResultShowAll": "Zeige alle {{ count }} Ergebnisse",
      "formSearchResultGroupLocations": "Skiort",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Regionen",
      "formSearchResultGroupCountries": "Länder",
      "formSearchButtonLabelDelivery": "Ab {{price}}",
      "deliverToHotel": "Ich möchte, dass die Ausrüstung kostenlos zu meiner Unterkunft geliefert wird!",
      "formStartDate": "Erster Miettag",
      "formEndDate": "Letzter Miettag",
      "formNumberOfPeople": "Anzahl der Personen",
      "formAdultsLabel": "Erwachsene",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "Erwachsene",
        "adultSingle": "Erwachsener",
        "adultMultiple": "Erwachsene",
        "childNone": "Kinder",
        "childSingle": "Kind",
        "childMultiple": "Kinder"
      },
      "formAdultsLabelInfo": "über 18 Jahre bei Mietantritt",
      "formChildrenLabel": "Kinder",
      "formChildrenLabelInfo": "unter 18 Jahre bei Mietantritt",
      "formChildInputLabelInfo": "Wie alt ist Ihr Kind / sind Ihre Kinder bei Mietantritt?",
      "formChildInputPlaceholder": "ist wie alt?",
      "formPromotionCode": "Promotion Code",
      "formPromotionCodeNotFound": "Dieser Promotioncode existiert nicht.",
      "formSearchButtonLabel": "SUCHEN",
      "promocode": {
        "couponCodeIsInCart": "Der Couponcode {{ code }} wurde in ihrem Warenkorb hinterlegt und wird auf der Checkout-Seite berücksichtigt.",
        "typePromo": "PROMO",
        "typeCoupon": "COUPON"
      },
      "noResults": "Keine Ergebnisse gefunden"
    },
    "shopSort": {
      "sortByHotel": "Distanz zu deiner Unterkunft",
      "sortPriceDistanceTooltip": "Sortieren nach „Preis & Entfernung\" sortiert die günstigsten Geschäfte nach oben (die direkt in der gewählten Stadt liegen) und die teureren nach unten. Unterhalb dieser „direkt im Ort gelegenen\" Geschäfte finden Sie weitere Geschäfte, die nach der Entfernung außerhalb Ihres ausgewählten Ortes geordnet sind. Eine Ausnahme bilden die mit „TOP SHOP\" und „BEST PRICE\" gekennzeichneten Shops (kostenpflichtig), die immer höher gerankt werden."
    },
    "navigation": {
      "skihire": "Skiverleih",
      "skischool": "Skischulen",
      "accommodation": "Unterkünfte",
      "aboutUs": "Über uns",
      "helpCenter": "Hilfe & Support",
      "subnavBooking": "Buchung",
      "subnavAdditionalOffers": "Zusatzangebote",
      "subnavGroupBooking": "Gruppenbuchungen",
      "subnavTermsAndConditions": "AGBs",
      "subnavBecomePartner": "Werden Sie Partner",
      "subnavPrivacyPolicy": "Datenschutzbestimmung",
      "subnavHelp": "Kontakt",
      "myAlpinresorts": "Mein Alpy.com",
      "subnavLogin": "Login",
      "subnavLogout": "Logout",
      "subnavBookingsAndCancellations": "Buchungen & Stornierungen",
      "subnavPersonalSettings": "Persönliche Einstellugen",
      "career": "Karriere"
    },
    "geoIp": {
      "chooseACountry": "Bitte wählen Sie ein Land"
    }
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "Über Alpy.com",
      "metaDescription": "Hier finden Sie alle Informationen zum Team von Alpy.com, Vertrauen Sie einem der größten Skiverleih und Skischulen Netzwerke Europas!"
    },
    "imprint": {
      "title": "Impressum {{ productName }}",
      "metaDescription": "Impressum von {{ productName }}"
    },
    "privacy": {
      "title": "Datenschutzbestimmungen von {{ productName }}",
      "metaDescription": "Datenschutzbestimmungen von {{ productName }}"
    },
    "termsAndConditions": {
      "title": "Allgemeine Geschäftsbedingungen | {{ productName }}",
      "metaDescription": "Datenschutzbestimmungen von {{ productName }}"
    },
    "additionalOffers": {
      "title": "Zusatzangebote",
      "metaDescription": ""
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "buchung-stornieren",
    "SKIHIREENTRY": "skiverleih",
    "COUNTRIES": "laender",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "suche"
    },
    "SKISCHOOLENTRY": "skischule",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "impressum",
      "PRIVACYPOLICY": "datenschutzbestimmungen",
      "TERMSANDCONDITIONS": "agbs",
      "HELP": "hilfe",
      "ABOUTUS": "ueber-uns",
      "ADDITIONALOFFERS": "zusatzangebote",
      "HOWTO": "anleitung"
    }
  }
}
